import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AlertCircle, Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/Brand";
import { api, errMsg } from "@/lib/api";

function Done({ data }) {
  const navigate = useNavigate();
  return (
    <div className="space-y-5 text-center" data-testid="confirm-email-success">
      <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-emerald-500/15 text-emerald-500"><Check className="h-7 w-7" /></span>
      <div>
        <h1 className="text-2xl font-bold sm:text-3xl">E-mail confirmado!</h1>
        <p className="mt-1 text-muted-foreground">{data.nome_fantasia} já pode entrar no sistema.</p>
      </div>
      <div className="card-surface space-y-2 p-5">
        <p className="eyebrow">Seu número de acesso</p>
        <p className="font-mono text-4xl font-bold tracking-[0.2em] text-primary" data-testid="confirm-access-number">{data.access_number}</p>
      </div>
      <Button className="h-12 w-full" onClick={() => navigate("/login", { state: { access_number: data.access_number, login: data.login } })} data-testid="confirm-go-login-btn">Entrar no sistema</Button>
    </div>
  );
}

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const [st, setSt] = useState({ status: "loading" });
  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setSt({ status: "error", msg: "Link inválido. Peça um novo e-mail de confirmação na tela de login." });
      return;
    }
    api.post("/auth/confirm-email", { token }).then((r) => setSt({ status: "ok", data: r.data })).catch((e) => setSt({ status: "error", msg: errMsg(e) }));
  }, [params]);
  return (
    <div className="grain flex min-h-screen items-center justify-center p-4 sm:p-8">
      <div className="w-full max-w-md space-y-6">
        <Link to="/login" className="flex items-center gap-3"><BrandMark tone="bg-primary text-primary-foreground" testId="confirm-brand" /><span className="font-display text-lg font-bold">FSCsistemas</span></Link>
        <div className="card-surface p-6 sm:p-8">
          {st.status === "loading" && <p className="flex items-center justify-center gap-2 py-8 text-muted-foreground" data-testid="confirm-email-loading"><Loader2 className="h-5 w-5 animate-spin" />Confirmando seu e-mail…</p>}
          {st.status === "ok" && <Done data={st.data} />}
          {st.status === "error" && (
            <div className="space-y-5 text-center" data-testid="confirm-email-error">
              <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-red-500/15 text-red-500"><AlertCircle className="h-7 w-7" /></span>
              <p className="text-sm text-muted-foreground">{st.msg}</p>
              <Button asChild className="h-12 w-full"><Link to="/login" data-testid="confirm-error-login-btn">Ir para o login</Link></Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
